import replaceProductInUrl from './replaceProductInUrl';

export default ({ currentProject, redirectToProductIds, currentToolId }) => {
  if (redirectToProductIds && currentToolId) {
    const alternativeProduct = currentProject?.products.find(
      (p) =>
        redirectToProductIds.includes(p.key) &&
        p?.tools.find(({ key }) => key === currentToolId)
    );
    const alternativeTool = alternativeProduct?.tools.find(
      ({ key }) => key === currentToolId
    );
    if (alternativeTool) {
      return replaceProductInUrl(window.location.href, alternativeTool.url);
    }
  }
  return '';
};
